"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TenantIdSchema = exports.EntityIdSchema = void 0;
exports.generateId = generateId;
const zod_1 = require("zod");
exports.EntityIdSchema = zod_1.z.string().min(1).describe('Unique entity identifier');
exports.TenantIdSchema = zod_1.z.string().min(1).describe('Tenant identifier');
function generateId(prefix) {
    return `${prefix}_${Date.now()}`;
}
//# sourceMappingURL=id.schema.js.map